import { render, staticRenderFns } from "./Card-Info.vue?vue&type=template&id=50b9ec36&"
import script from "./Card-Info.vue?vue&type=script&lang=js&"
export * from "./Card-Info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports